import React, { useEffect, useRef, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  no_image,
  search_icon,
  view_icon,
} from "../../assets/imgs";
import { admin_list, Transaction_list } from "../redux/api/dummyJson";
import {
  useLazyPropertiesListDropQuery,
  useLazyPropertiesListQuery,
  useLazyTotalLocationsListQuery,
  useSubscriptionRequestActionMutation,
  useSubscriptionRequestApproveMutation,
  useSubscriptionRequestListMutation,
  useSubscriptionRequestRejectionMutation,
} from "../redux/api/api";
import moment from "moment";
import CustomSearchSelect from "../../components/Searchbox/CustomSearch";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const Request = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [cities, setCities] = useState([]);
  const [properties, setProperties] = useState([]);
  const [list, setList] = useState([]);
  const [fromdate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [city, setCity] = useState("");
  const [search, setSearch] = useState("");
  const [selectedCityId, setSelectedCityId] = useState("");
  const [selectedPropertyId, setSelectedPropertyId] = useState("");
  const [locationLoader, setLocationLoader] = useState(false);

  const rolePermissions = JSON.parse(localStorage.getItem("permissions"));

  const [requestListApi] = useSubscriptionRequestListMutation();
  const [requestApproveApi] = useSubscriptionRequestApproveMutation();
  const [requestRejectApi] = useSubscriptionRequestRejectionMutation();
  const [getCityApi] = useLazyTotalLocationsListQuery();
  const [getPropertyApi] = useLazyPropertiesListDropQuery();

  const requestApprove = (subId, propId, ownId, id) => {
    // console.log("ids",subId,propId,ownId)
    // return
    const formdata = new FormData();
    formdata.append("subscription_id", subId);
    formdata.append("property_id", propId);
    formdata.append("owner_id", ownId);
    formdata.append("status", 5);

    requestApproveApi({ payload: formdata, id: id })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        // if (res?.status == "success") {
        toast.success("Approved Succesfully");
        // }
        requestList();
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const requestReject = (subId, propId, ownId, id) => {
    const formdata = new FormData();
    formdata.append("subscription_id", subId);
    formdata.append("property_id", propId);
    formdata.append("owner_id", ownId);
    formdata.append("status", 6);

    requestRejectApi({ payload: formdata, id: id })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          toast.success(res?.message);
        }
        requestList();
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getLocations = () => {
    setLocationLoader(true);
    getCityApi()
      .unwrap()
      .then((res) => {
        console.log(res);
        let temp = res?.data?.filter((item) => item?.type == 3);
        setCities(temp);
        setLocationLoader(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getProperties = () => {
    getPropertyApi()
      .unwrap()
      .then((res) => {
        console.log(res);
        setProperties(res?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const requestList = (
    pageno,
    fromdate,
    toDate,
    selectedPropertyId,
    selectedCityId,
    search
  ) => {
    const formdata = new FormData();
    formdata.append("per_page", 10);
    formdata.append("page", pageno);
    if (fromdate && toDate) {
      formdata.append("from_date", moment(fromdate).format("YYYY-MM-DD"));
      formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    }

    if (selectedPropertyId) {
      formdata.append("property_name", selectedPropertyId);
    }
    if (selectedCityId) {
      formdata.append("city_id", selectedCityId);
    }
    if (search) {
      formdata.append("search", search);
    }
    formdata.append("row", 10);
    setFromDate(fromdate);
    setToDate(toDate);
    setCity(city);
    setProperties(properties);
    setSearch(search);
    requestListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = [];
        res?.data?.map((item, ind) => {
          let obj = { ...item };
          obj.current_page = res?.pagination?.current_page;
          temp.push(obj);
        });
        setList(temp);
        setPagecount(res?.pagination);
        // setSubscriptionId(res?.data?.)
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    requestList(
      pageno,
      fromdate,
      toDate,
      selectedPropertyId,
      selectedCityId,
      search
    );
    getLocations();
    getProperties();
  }, [pageno]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>
          );
        },
      },
      {
        Header: "Property ID",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {" "}
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", { state: { data: row.original } })
                }
              >
                {row?.original?.property?.property_id}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Property Name",
        accessor: "property",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {" "}
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", { state: { data: row.original } })
                }
              >
                {value?.name}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Owner Name",
        accessor: "owner",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {" "}
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/owner-view", {
                    state: { type: "view", id: row.original.owner_id },
                  })
                }
              >
                {value?.name}
              </p>{" "}
            </div>
          );
        },
      },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ value, row }) => {
          return <p>{value == 1 ? "Room" : "Individual"}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{row?.original?.property?.city?.name}</p>;
        },
      },
      {
        Header: "Requested Date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              {rolePermissions?.includes("CAN-STATUS-MMC CANCELLATION") && (
                <div className="d-flex ac-jc gap-2">
                  <button
                    onClick={() => {
                      requestApprove(
                        row.original.rz_subscription_id,
                        row.original.property_id,
                        row.original.owner_id,
                        row.original.id
                      );
                    }}
                    className="cust-btn approve-btn"
                  >
                    <p className="mb-0">Approve</p>
                  </button>
                  <button
                    onClick={() => {
                      requestReject(
                        row.original.rz_subscription_id,
                        row.original.property_id,
                        row.original.owner_id,
                        row.original.id
                      );
                    }}
                    className="cust-btn reject-btn"
                  >
                    <p className="mb-0">Reject</p>
                  </button>
                </div>
              )}
            </React.Fragment>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {/* {rolePermissions?.includes('CAN-VIEW-OWNER') && */}
                <button
                  onClick={() =>
                    navigate("/mmc-req-view", {
                      state: { type: "view", data: row.original },
                    })
                  }
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className="mx-2 edit-btn " />
                </button>
                {/* } */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  // console.log('cityId', selectedCityId)

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          MMC Cancellation - Request
        </h2>
      </div>
      <div className="d-flex ac-jb mt-3 gap-2">
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">
          From Date
        </label>
        <div className="w-15">
          <DatePicker
            type="date"
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="From Date"
            selected={fromdate}
            onChange={(e) => {
              requestList(1, e, toDate, selectedPropertyId, city, search);
            }}
          />
        </div>
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">
          To Date
        </label>
        <div className="w-15">
          <DatePicker
            type="date"
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="To Date"
            selected={toDate}
            onChange={(e) =>
              requestList(1, fromdate, e, selectedPropertyId, city, search)
            }
          />
        </div>
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">
          Property{" "}
        </label>
        <CustomSearchSelect
          options={properties}
          value={selectedPropertyId}
          onChange={(propValue) => {
            setSelectedPropertyId(propValue);
            requestList(1, fromdate, toDate, propValue, city, search);
          }}
          placeholder="Select Property"
          width="200px"
        />
        {/* <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">City</label> */}
        <CustomSearchSelect
          options={cities}
          value={selectedCityId}
          locationLoader={locationLoader}
          onChange={(value) => {
            setSelectedCityId(value);
            requestList(1, fromdate, toDate, selectedPropertyId, value, search);
          }}
          placeholder="Select City"
          width="200px"
        />
      </div>
      <div className="d-flex ac-js mt-3">
        <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
          Search
        </label>
        <div
          onChange={(e) =>
            requestList(
              1,
              fromdate,
              toDate,
              selectedPropertyId,
              selectedCityId,
              e.target.value
            )
          }
          className="search-input ms-2"
        >
          <input
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "100px" }}
          />
          <img src={search_icon} className="search" />
        </div>
      </div>
      {loading && (
        <div
          style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%" }}
        >
          <Spinner animation="border" className="primary1" />
        </div>
      )}
      <Table
        columns={columns}
        data={list}
        setPageno={setPageno}
        pagecount={pagecount}
        show={true}
      />
    </div>
  );
};

export default Request;
